import Vue from 'vue'
import '@babel/polyfill'
import App from './App'
import router from './router'
import store from './store'
import './filters'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/components/element-variables.scss'
import './assets/styles/common.styl'

import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/styles.css'
import { library, } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faChevronRight,
  faChevronDown,
  faBell,
  faBullhorn,
  faCaretDown,
  faCaretUp,
  faCircle,
  faDownload,
  faEdit,
  faEllipsisH,
  faExclamationTriangle,
  faExternalLinkAlt,
  faInfoCircle,
  faLink,
  faMapMarkerAlt,
  faPen,
  faPrint,
  faSpinner,
  faStream,
  faTimesCircle,
  faTimes,
  faTrashAlt,
  faPlusCircle,
  faIndustry,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon, } from '@fortawesome/vue-fontawesome'
import { init, } from '@sentry/browser'
import { Vue as vueIntegration, } from '@sentry/integrations'

import { VueReCaptcha, } from 'vue-recaptcha-v3'

import axios from 'axios'
import { baseURL, googleKey, cookieBotKey, } from './constants/api'
import VueAxios from 'vue-axios'

import * as VueGoogleMaps from 'vue2-google-maps'
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin'

import hljs from 'highlight.js'

Vue.directive('highlightjs', {
  deep: true,
  bind: (el, binding) => {
    // on first bind, highlight all targets
    let targets = el.querySelectorAll('code')
    targets.forEach((target) => {
      // if a value is directly assigned to the directive, use this
      // instead of the element content.
      if (binding.value) {
        target.innerHTML = binding.value
      }
      hljs.highlightBlock(target)
    })
  },
  componentUpdated: (el, binding) => {
    // after an update, re-fill the content and then highlight
    let targets = el.querySelectorAll('code')
    targets.forEach((target) => {
      if (binding.value) {
        target.innerHTML = binding.value
        hljs.highlightBlock(target)
      }
    })
  },
})

if (process.env.STAGE) {
  console.log('STAGE')
} else if (process.env.NODE_ENV === 'development') {
  console.log('DEV')
}

Vue.use(VueReCaptcha, { siteKey: process.env.RECAPTCHA_KEY, })

Vue.use(VueGoogleMaps, {
  load: {
    key: googleKey,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    // If you want to set the version, you can do so:
    // v: '3.26',
  },

  // If you intend to programmatically custom event listener code
  // (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  // instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  // you might need to turn this on.
  // autobindAllEvents: false,

  // If you want to manually install components, e.g.
  // import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  // Vue.component('GmapMarker', GmapMarker)
  // then disable the following:
  // installComponents: true,
})

Vue.use(VueCookieBot, {
  cookieBotID: cookieBotKey,
})

if (process.env.LEISEARCH_SENTRY_ENABLED) {
  init({
    dsn: process.env.LEISEARCH_SENTRY_KEY,
    environment: process.env.NODE_ENV,
    maxBreadcrumbs: 50,
    integrations: [
      new vueIntegration({
        Vue,
        attachProps: true,
      }),
    ],
  })
}

// Axios
axios.defaults.baseURL = baseURL
Vue.use(VueAxios, axios)

library.add(
  faAngleLeft,
  faAngleRight,
  faArrowRight,
  faChevronRight,
  faChevronDown,
  faBell,
  faPlusCircle,
  faBullhorn,
  faTrashAlt,
  faCaretDown,
  faCaretUp,
  faCircle,
  faDownload,
  faEdit,
  faEllipsisH,
  faExclamationTriangle,
  faExternalLinkAlt,
  faInfoCircle,
  faLink,
  faMapMarkerAlt,
  faPen,
  faPrint,
  faSpinner,
  faStream,
  faTimesCircle,
  faTimes,
  faTrashAlt,
  faIndustry,
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(ElementUI, { locale, })

const datepickerOptions = {
  colors: {
    selected: '#4e608a',
    inRange: '#7085a5',
    selectedText: '#fff',
    text: '#767776',
    inRangeBorder: '#4e608a',
    disabled: '#fff',
  },
}
Vue.use(AirbnbStyleDatepicker, datepickerOptions)

Vue.config.productionTip = false
Vue.config.devtools = true

// handle navigationDuplicate globally
const op = router.push
router.push = function push (loc, resolve, reject) {
  if (resolve || reject) return op.call(this, loc, resolve, reject)
  return op.call(this, loc).catch((err) => err)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App, },
  template: '<App/>',
})

Vue.config.devtools = true



// WEBPACK FOOTER //
// ./src/main.js